import { render, staticRenderFns } from "./UcPropertyMiniCard.yaml?vue&type=template&id=979ed856&component"
import script from "./UcPropertyMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcPropertyMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports